import React from 'react';

// import { Container } from './styles';

export default function Production() {
  return <h1>Cadastros</h1>;
}
